'use client';

import { useEffect } from 'react';
import { resolveMediaUrl } from '@/lib/api';

/**
 * Injecte dynamiquement le favicon dans <head> a partir du favicon_url
 * configure dans le super-admin. Permet de changer le favicon sans rebuild.
 */
export default function FaviconInjector({ faviconUrl }) {
  useEffect(() => {
    if (!faviconUrl) return;
    const url = resolveMediaUrl(faviconUrl);
    if (!url) return;

    // Supprimer les anciens favicons injectes par cette logique
    document.querySelectorAll("link[data-vitrine-favicon='true']").forEach(el => el.remove());

    const link = document.createElement('link');
    link.rel = 'icon';
    link.href = url;
    link.setAttribute('data-vitrine-favicon', 'true');
    document.head.appendChild(link);
  }, [faviconUrl]);

  return null;
}
